import React, { useEffect } from "react";

const Vision = () => {

  useEffect(() => {
            const handleScroll = () => {
              const windowHeight = window.innerHeight;
              const scrollY = window.scrollY;
        
              const animatables = document.querySelectorAll('.animatable');
        
              animatables.forEach(animatable => {
                const elementTop = animatable.getBoundingClientRect().top + scrollY;
                const elementBottom = elementTop + animatable.clientHeight;
        
                // Check if element is in the viewport
                if (scrollY + windowHeight > elementTop && scrollY < elementBottom) {
                  animatable.classList.add('animated');
                  animatable.classList.remove('animatable');
                } else {
                  // Reset the animation when the element is out of view
                  animatable.classList.remove('animated');
                  animatable.classList.add('animatable');
                }
              });
            };
        
            window.addEventListener('scroll', handleScroll);
            handleScroll(); // Trigger animation on mount
        
            return () => {
              window.removeEventListener('scroll', handleScroll);
            };
          }, []);


  return (
    <div className="vision-mission-container">
      <section className="vision-section">
        <h1 className="vision-title block animatable bounceInLeft">Vision & Mission</h1>

        {/* Vision Section */}
        <div className="vision-content block animatable bounceIn">
          <h2 className="vision-subtitle">Our Vision</h2>
          <p className="vision-text">
            "To redefine education through a holistic approach that integrates academic excellence, character building, and physical development. We envision a future where every student is equipped with the skills, knowledge, and values needed to succeed in a rapidly evolving global landscape."
          </p>

          <h3 className="key-aspirations-title">Key Aspirations:</h3>
          <ul className="key-aspirations-list">
            <li>Establish a network of institutions that set benchmarks for quality education.</li>
            <li>Foster a community of lifelong learners who are creative, critical thinkers.</li>
            <li>Promote a harmonious balance between academic learning and extracurricular excellence.</li>
            <li>Develop leaders who are empathetic, innovative, and solution-oriented.</li>
          </ul>
        </div>

        {/* Mission Section */}
        <div className="mission-content block animatable bounceInLeft">
          <h2 className="vision-subtitle">Our Mission</h2>
          <p className="vision-text">
            "Our mission is to inspire, nurture, and empower students to achieve their fullest potential. By combining traditional educational values with cutting-edge technology and innovative practices, we aim to create a platform for meaningful learning and personal growth."
          </p>

          <h3 className="commitments-title">Our Commitments:</h3>
          <ul className="commitments-list">
            <li>
              <strong>Academic Excellence:</strong>
              <ul>
                <li>Provide a curriculum that emphasizes conceptual understanding, critical thinking, and problem-solving skills.</li>
                <li>Introduce advanced labs, AI integration, and STEAM programs across our institutions.</li>
              </ul>
            </li>
            <li>
              <strong>Holistic Development:</strong>
              <ul>
                <li>Promote extracurricular activities like arts, music, and drama to enrich creativity.</li>
                <li>Prioritize sports training to instill discipline and physical well-being.</li>
                <li>Encourage participation in community service projects to foster social responsibility.</li>
              </ul>
            </li>
            <li>
              <strong>Innovation and Technology:</strong>
              <ul>
                <li>Leverage digital tools for smarter and more engaging learning experiences.</li>
                <li>Continuously upgrade infrastructure to meet international standards.</li>
              </ul>
            </li>
            <li>
              <strong>Inclusivity and Values:</strong>
              <ul>
                <li>Create a nurturing and inclusive environment where every student feels valued.</li>
                <li>Emphasize ethics, empathy, and leadership qualities through value-based education.</li>
              </ul>
            </li>
          </ul>
        </div>

        {/* Strategic Goals Section */}
        <div className="vision-content block animatable bounceInRight">
          <h2 className="vision-subtitle">Strategic Goals</h2>
          <ul className="strategic-goals-list">
            <li>Expand the Aekaksh School network to reach more cities while maintaining quality.</li>
            <li>Build Soul Sportza into a national-level sports brand, recognized for producing top athletes.</li>
            <li>Develop partnerships with global educational organizations to bring international best practices to Hyderabad.</li>
            <li>Use AI and digital tools to streamline operations and improve educational outcomes.</li>
          </ul>
        </div>

        {/* Call to Action Section */}
        <div className="vision-content block animatable bounceInLeft">
          <h2 className="vision-subtitle">Call to Action</h2>
          <p className="call-to-action-text">
            "Join us in creating a future where every child’s potential is realized. Together, we can inspire a generation of leaders, innovators, and change-makers."
          </p>
        </div>
      </section>
    </div>
  );
};

export default Vision;
